module.exports = {"home":"Home"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/translations.json
// module id = 3840
// module chunks = 168707334958949